<template>
    <div
        :class="vertical ? 'flex-col' : 'flex-row'"
        class="flex items-center justify-center"
        data-testid="animation-loading"
    >
        <ProgressSpinner class="m-0 h-10 p-0" />
        <span
            v-if="text"
            :class="{
                'mt-2': vertical,
                'ms-2': !vertical,
            }"
            >{{ text }}</span
        >
    </div>
</template>

<script lang="ts" setup>
    defineProps<{ text: string; vertical?: boolean }>();
</script>
